import script from "./UiFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./UiFilter.vue?vue&type=script&setup=true&lang=js"

import "./UiFilter.vue?vue&type=style&index=0&id=020eb927&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-020eb927"]])

export default __exports__